import { render, staticRenderFns } from "./botActions.vue?vue&type=template&id=8c3ef24a"
import script from "./botActions.vue?vue&type=script&lang=js"
export * from "./botActions.vue?vue&type=script&lang=js"
import style0 from "./botActions.vue?vue&type=style&index=0&id=8c3ef24a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports